import React from 'react'
import { Button, Grid, IconButton, Paper, Typography, Box } from '@mui/material'

const ResourcesPage = () => {
  return (
    <>
      <Grid container spacing={1} style={{ margin: '10px' }}>
        <Grid item>
          <Typography
            variant='h7'
            component='div'
            style={{
              fontSize: 'xx-large',
              textAlign: '-webkit-right',
              width: '70%',
              fontFamily: 'emoji'
            }}
          >
            <strong>{'RESOURCES (Click to Download)'}</strong>
          </Typography>
        </Grid>
      </Grid>
    </>
  )
}

export default ResourcesPage
